// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2iADj","location":"Header_location__imSSy"};